import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Facility = (function() {
  function Id(facilityId, eager) {
    if (logComponent('Facility')) { console.debug('Facility Id'); }
    let params = {};
    if (eager) params.eager = true;

    return axios.get(`api/Facility/${facilityId}`, getConfig( params));
  }

  function GetByCurrentUser(monitoredIndividualId, eager) {
    if (logComponent('Facility')) { console.debug('Facility GetByCurrentUser'); }
    let params = {};
    if (monitoredIndividualId) params.monitoredIndividualId = monitoredIndividualId;
    if (eager) params.eager = true;

    return axios.get('api/Facility/GetByCurrentUser', getConfig( params));
  }

  function GetByUser(userId, monitoredIndividualId) {
    if (logComponent('Facility')) { console.debug('Facility GetByUser'); }
    const params = { userId };
    if (monitoredIndividualId) params.monitoredIndividualId = monitoredIndividualId;

    return axios.get('api/Facility/GetByUser', getConfig( params));
  }

  function GetAllFacilityUsers(facilityId) {
    if (logComponent('Facility')) { console.debug('Facility GetAllFacilityUsers'); }
    const params = { facilityId };
    return axios.get('api/Facility/GetAllFacilityUsers', getConfig( params));
  }

  function GetAllMonitoredIndividuals(facilityId) {
    if (logComponent('Facility')) { console.debug('Facility GetAllMonitoredIndividuals'); }
    const params = { facilityId };
    return axios.get('api/Facility/GetAllMonitoredIndividuals', getConfig( params));  
  }

  function GetUnits(hasLinkedMonitoredIndividual) {
    if (logComponent('Facility')) { console.debug('Facility GetUnits'); }
    const params = { };
    params.hasLinkedMonitoredIndividual = hasLinkedMonitoredIndividual ? true : false;

    return axios.get('api/Facility/GetUnits', getConfig( params));
  }

  function GetAll() {
    if (logComponent('Facility')) { console.debug('Facility GetAll'); }
    return axios.get('api/Facility/GetAll', getConfig());
  }

  function GetAllModules(facilityId, groupType) {
    if (logComponent('Facility')) { console.debug('Facility GetAllModules'); }
    const params = { facilityId, groupType };
    return axios.get('api/Facility/GetAllModules', getConfig( params));
  }

  function GetAllGroups(facilityId) {
    if (logComponent('Facility')) { console.debug('Facility GetAllGroups'); }
    const params = { facilityId };
    return axios.get('api/Facility/GetAllGroups', getConfig(params));
  }

  function GetLogo(facilityId) {
    if (logComponent('Facility')) { console.debug('Facility GetLogo'); }
    return axios.get(`api/Facility/Logo/${facilityId}`);
  }

  function PutLogo(facilityId, logo) {
    if (logComponent('Facility')) { console.debug('Facility PutLogo'); }
    let config = getConfig();
    config.headers['Content-Type'] = 'multipart/form-data';
  
    return axios.put(`api/Facility/Logo/${facilityId}`, logo, config);
  }

  function AddOrUpdate(facility) {
    if (logComponent('Facility')) { console.debug('Facility AddOrUpdate'); }
    return axios.put('api/Facility/AddOrUpdate', facility, getConfig());
  }

  function SetCheckInNotesRequirements(facilityId, isStaffNoteRequired, isFamilyNoteRequired) {
    if (logComponent('Facility')) { console.debug('Facility SetCheckInNotesRequirements'); }
    const params = { facilityId, isStaffNoteRequired, isFamilyNoteRequired };

    return axios.put('api/Facility/SetCheckInNotesRequirements', null, getConfig( params));
  }

  function AddModule(facilityId, moduleId, groupTypes) {
    if (logComponent('Facility')) { console.debug('Facility AddModule'); }
    const data = {
      FacilityId: facilityId,
      ModuleId: moduleId
    };

    const params = { groupTypes };

    return axios.put('api/Facility/AddModule', data, getConfig( params));
  }

  function RemoveModule(facilityId, moduleId, groupTypes) {
    if (logComponent('Facility')) { console.debug('Facility RemoveModule'); }
    const data = {
      FacilityId: facilityId,
      ModuleId: moduleId
    };

    const params = { groupTypes };

    return axios.delete('api/Facility/RemoveModule', getConfig( params, data));    
  }
  
 
  return {
    Id,
    GetByCurrentUser,
    GetByUser,
    GetAllFacilityUsers,
    GetAllMonitoredIndividuals,
    GetUnits,
    GetAll,
    GetAllModules,
    GetAllGroups,
    Logo: {
      Id: {
        get: GetLogo,
        put: PutLogo
      }
    },
    AddOrUpdate,
    SetCheckInNotesRequirements,
    AddModule,
    RemoveModule
  }
})();

export default Facility;